import { PropsWithChildren } from "react";
import { GestureHandlerRootView } from "react-native-gesture-handler";

interface Props extends PropsWithChildren {}

export const GestureHandlerProvider = ({ children }: Props) => (
	<GestureHandlerRootView className="flex-1">{children}</GestureHandlerRootView>
);
